import { render, staticRenderFns } from "./BankLink.vue?vue&type=template&id=1f6a9dcf&scoped=true&"
import script from "./BankLink.vue?vue&type=script&lang=ts&"
export * from "./BankLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a9dcf",
  null
  
)

export default component.exports